import { QuoteForm } from "@/components/QuoteForm";
import { SectionHeading } from "@/components/SectionHeading";
import { Card, CardContent } from "@/components/ui/card";
import { productOptions } from "@/data/siteContent";

export default function WholesalePage({ content }) {
  const isHindi = content.locale === "hi";
  const wholesaleBenefits = Array.isArray(content?.wholesale?.benefits) ? content.wholesale.benefits : [];
  const featuredProducts = Array.isArray(content?.featuredProducts) ? content.featuredProducts : [];

  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <SectionHeading eyebrow={isHindi ? "थोक सप्लाई" : "Wholesale"} title={content.wholesale.title} description={content.wholesale.description} />
      <div className="mt-10 grid gap-6 lg:grid-cols-[0.95fr_1.05fr]">
        <div className="grid gap-5">
          {wholesaleBenefits.map((item, index) => (
            <Card key={item} className="rounded-[28px] border-stone-200 bg-white">
              <CardContent className="p-6 text-sm leading-7 text-stone-600" data-testid={`wholesale-page-benefit-${index + 1}`}>
                {item}
              </CardContent>
            </Card>
          ))}
          <Card className="rounded-[28px] border-primary/10 bg-primary text-white">
            <CardContent className="space-y-4 p-6">
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-emerald-100" data-testid="wholesale-page-categories-title">
                {isHindi ? "उत्पाद श्रेणियाँ" : "Product categories"}
              </p>
              <div className="grid gap-3 sm:grid-cols-2">
                {featuredProducts.slice(0, 3).map((product) => (
                  <div key={product.slug} className="rounded-[20px] bg-white/10 px-4 py-4 text-sm font-medium text-white" data-testid={`wholesale-page-category-${product.slug}`}>
                    {product.title}
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>

        <div id="quote-request">
          <QuoteForm copy={{ ...content.quoteForm, submitQuote: content.ctas.submitQuote, submitContact: content.ctas.submitContact }} products={productOptions} language={content.locale} mode="quote" />
        </div>
      </div>
    </div>
  );
}